<template>
    <div>
        <!-- Modal-->
        <div class="modal fade" ref="modal" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered max-w-800px" role="document"><div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ __('general.filter') }}: {{ filterable }}
                        </h5>
                    </div>
                    <div class="modal-body">
                        <slot/>
                    </div>
                    <div v-if="filtersChanged" class="modal-footer justify-content-start">
                        <button class="btn btn-success px-5" @click="applyChanges">
                            <i class="fas fa-check" />
                            {{ __('actions.filter.apply') }}
                        </button>
                        <button class="btn btn-secondary" @click="hideModal">
                            <i class="fas fa-times" />
                            {{ __('actions.abort') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Button -->
        <div class="mb-2">
            <FilterButton :class="[type]"
                          data-toggle="modal"
                          :data-target="'#' + modalId">
                {{ filterable }}: {{ value }}
                <i class="fas fa-pen ml-1" style="font-size: .9em; opacity: 0.75;"/>
            </FilterButton>
        </div>
    </div>
</template>

<script>
import crypto from "crypto";
import FilterButton from "@components/Stats/FilterButton.vue";

export default {
    components: {FilterButton},

    props: {
        filterable: String,
        filtersChanged: Boolean,
        type: {
            type: String,
            default: 'btn-primary'
        },
        value: {
            types: [String, Number]
        }
    },

    methods: {
        applyChanges() {
            this.$emit('apply');
            this.hideModal();
        },

        hideModal() {
            $(this.$refs.modal).modal('hide');
        }
    },

    computed: {
        modalId() {
            return 'modal' + crypto.randomBytes(20).toString('hex');
        }
    }
}
</script>
